/* istanbul ignore file */
export enum EventPaidType {
  free = "free",
  ownExpense = "ownExpense",
  fixed = "fixed"
}
